import { Component, OnInit, ViewChild } from '@angular/core';
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { PagerserviceService } from "../services/pagerservice.service";
import { NotificationsService } from "angular2-notifications";
import { UserService } from "../services/user.service";
import { Router } from "@angular/router";
import { AdminService } from "../services/admin.service";
import { MatDialog, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { AddEditAdminlist } from '../addeditadminlist/addeditadminlist.component';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { ResetAdminBlockDialog } from '../resetadminblockdialog/resetadminblockdialog.component';

const defaults = {
    notif: {
        timeOut: 3000,
        showProgressBar: true,
        pauseOnHover: false,
        clickToClose: true,
        maxLength: 50
    }
}
@Component({
    selector: 'app-manageadmin',
    templateUrl: './manageadmin.component.html',
    styleUrls: ['./manageadmin.component.css']
})
export class ManageadminComponent implements OnInit {
    displayedColumns = [
        'name',
        'email',
        'phone',
        'telegram_chat_id',
        'group',
        'status',
        'createdAt',
        'action'
    ];
    public dataSource = new MatTableDataSource();
    pageSize = 25;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    customerList: Array<any>;
    customerFlag = false;
    walletsList: Array<any>;
    walletsres: Array<any>;
    cArr: Array<any>;
    setCustomerList: {};
    customerListById: {};
    /* Pagination fields */
    // pager Number
    pager: number;

    // pager object
    pager1: any = {};
    Tpager: number;
    // paged items
    pagedItems: Array<any>;

    /*Filter variables*/
    serach: string;
    FilPerpage: number;
    FilPage: number;
    customerid = '';

    /* Bank Object */
    banklist = {};
    phonecodelist: Array<any>;

    walletActive: string;
    IPcountry = 'IN';
    phonenumcheck = false;
    currentPag: any = 0;
    /* For Add New Customer Object */
    permission: string;
    totalRecords = 0;
    countries: any[];
    constructor(private userService: UserService,
        private router: Router,
        private notifSer: NotificationsService,
        private spinnerService: Ng4LoadingSpinnerService,
        private pagerService: PagerserviceService,
        private adminService: AdminService,
        private dialog: MatDialog,) { }
    public declarativeFormCaptchaValue: string;
    isSuperAdmin = false;
    // Inline edit of a row's Telegram Chat ID (super admin, any admin including super admins)
    editingTelegramId: string = null;
    telegramDraft = '';
    savingTelegram = false;
    ngOnInit() {
        // check user is logged or not
        if (!this.userService.isLoggedIn()) {
            this.router.navigateByUrl('/index');
        } else if (this.userService.getUserDetails().group !== 'super-admin') {
            // Manage Admin is a super-admin-only page
            this.router.navigateByUrl('/customer');
        } else {
            this.isSuperAdmin = true;
            if (typeof localStorage.getItem('adminmenus') != 'undefined' && localStorage.getItem('adminmenus').length > 0) {
                var spt = this.router.url.split("/");
                var menu_url = spt[1];
                var adminmenus = JSON.parse(localStorage.getItem('adminmenus'));
                var adminrules = JSON.parse(localStorage.getItem('adminrules'));
                var index = adminmenus.findIndex(x => (x.menu_url) === menu_url);
                if (index != -1) {
                    var menuid = adminmenus[index]._id;
                    var adindex = adminrules.findIndex(x => (x.menu_id) === menuid.toString());
                    this.permission = (adindex != -1) ? adminrules[adindex].permission : "write";
                }
            }

            this.walletActive = null;
            this.getAdminUserList();

        }
    }
    addEditAdminlist(element) {
        var new_element = {};
        if (!element) {
            new_element = {
                'name': '',
                'email': '',
                'group': '',
                'phone': '',
                'telegram_chat_id': '',
                'mode': 'create',
                '_id': '',
            };
        }
        else {
            new_element = {
                'name': element.name,
                'email': element.email,
                'group': element.group,
                'phone': element.phone,
                'telegram_chat_id': element.telegram_chat_id,
                'mode': 'edit',
                '_id': element._id,
            };
        }

        const dialogRef = this.dialog.open(AddEditAdminlist, {
            width: '600px',
            data: new_element,
        }).afterClosed().subscribe(result => {
            if (result.success) {
                this.getAdminUserList()
            }
        });
    }
    // For delete users
    deleteCustomer(userId: string) {
        try {
            this.dialog.open(ConfirmationDialogComponent, {
                data: {
                    message: `Are you sure want to  delete customer?`,
                    buttonText: {
                        ok: 'Yes',
                        cancel: 'No'
                    }
                }
            }).afterClosed().subscribe((confirmed: boolean) => {
                if (confirmed) {
                    const { notif } = defaults;
                    this.adminService.deleteAdminUser(userId).subscribe(done => {
                        // this.csrf();
                        this.spinnerService.hide();
                        this.notifSer.success(
                            'Success',
                            'Admin has been deleted', notif
                        )
                        this.getAdminUserList();
                    }, (err) => {
                        this.spinnerService.hide();
                        this.notifSer.error(
                            'Error',
                            err.message, notif
                        )
                    })

                }
            });
        } catch (error) {
            console.log(error);
        }
    }
    // Reset another admin's failed-login lockout. Requires the currently
    // logged-in super-admin to re-enter their own password (verified
    // server-side in resetAdminBlock) before the lockout is cleared.
    resetAdminBlock(element) {
        this.dialog.open(ResetAdminBlockDialog, {
            width: '400px',
            data: { _id: element._id, name: element.name },
        }).afterClosed().subscribe(result => {
            if (result && result.success) {
                this.getAdminUserList();
            }
        });
    }
    telInputObject(obj) {
        obj.intlTelInput('setCountry', 'in');
    }

    getAdminUserList() {
        const { notif } = defaults;
        this.spinnerService.show();
        this.adminService.getAdminUsersList().subscribe(list => {
            if (list.status) {
                // this.actionEditPerformed = false;
                this.dataSource = new MatTableDataSource(list.customers);
                this.dataSource.paginator = this.paginator;
                this.dataSource.sort = this.sort;
                this.customerList = list.customers;
                // this.Tpager = list.pages;
                // this.currentPag = list.current
                // this.setPage(this.FilPage);
            }
            this.customerFlag = true;
            this.totalRecords = list.total;
            this.spinnerService.hide();
        }, (err) => {
            this.spinnerService.hide();
            this.notifSer.error(
                'Error',
                err.error.message,
                notif
            )
        })
    }
    /* Pagination of customer details */
    setPage(page: number) {
        // get pager object from service
        this.pager1 = this.pagerService.getPager(this.Tpager, page);
    }

    setPageOnClick(page: number) {
        this.pager = page;
        this.FilPage = this.pager;
        this.getAdminUserList();
    }

    /* Serach Event */
    sreach(event: any) {
        this.serach = event.target.value;
        this.getAdminUserList();
    }

    customerActivate(customer) {
        const { notif } = defaults;
        customer.status = 'Active';

        this.spinnerService.show();
        this.userService.csrf().subscribe(user => {
            customer['_csrf'] = user._csrf;
            this.adminService.updateAdminUserStatus(customer).subscribe(done => {
                this.getAdminUserList();
                this.spinnerService.hide();
                this.notifSer.success(
                    'Success',
                    done.message,
                    notif
                )
            }, (err) => {
                this.spinnerService.hide();
                this.notifSer.error(
                    'Error',
                    err.message,
                    notif
                )
            })
        });

    }
    applyFilter(filterValue: string) {
        filterValue = filterValue.trim(); // Remove whitespace
        filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
        this.dataSource.filter = filterValue;
    }
    customerDeactivate(customer) {
        const { notif } = defaults;
        customer.status = 'Deactive';
        this.spinnerService.show();
        this.userService.csrf().subscribe(user => {
            customer['_csrf'] = user._csrf;
            this.adminService.updateAdminUserStatus(customer).subscribe(done => {
                this.getAdminUserList();
                this.spinnerService.hide();
                this.notifSer.success(
                    'Success',
                    done.message,
                    notif
                )
            }, (err) => {
                this.spinnerService.hide();
                this.notifSer.error(
                    'Error',
                    err.message,
                    notif
                )

            })
        });

    }


    startTelegramEdit(row) {
        this.editingTelegramId = row._id;
        this.telegramDraft = row.telegram_chat_id || '';
    }

    cancelTelegramEdit() {
        this.editingTelegramId = null;
        this.telegramDraft = '';
    }

    isTelegramDraftValid() {
        const value = String(this.telegramDraft || '').trim();
        return value === '' || /^-?\d{5,20}$/.test(value);
    }

    saveTelegramEdit(row) {
        const { notif } = defaults;
        const value = String(this.telegramDraft || '').trim();
        if (!this.isTelegramDraftValid()) {
            this.notifSer.error('Error', 'Telegram Chat ID must be a number', notif);
            return;
        }
        if (value === (row.telegram_chat_id || '')) {
            this.cancelTelegramEdit();
            return;
        }
        this.savingTelegram = true;
        this.userService.csrf().subscribe(user => {
            this.adminService.updateAdminTelegramChatId({ _id: row._id, telegram_chat_id: value, _csrf: user._csrf }).subscribe(done => {
                this.savingTelegram = false;
                if (done.status) {
                    row.telegram_chat_id = value;
                    this.cancelTelegramEdit();
                    this.notifSer.success('Success', done.message, notif);
                } else {
                    this.notifSer.error('Error', done.message, notif);
                }
            }, (err) => {
                this.savingTelegram = false;
                this.notifSer.error('Error', (err.error && err.error.message) || err.message, notif);
            });
        }, () => {
            this.savingTelegram = false;
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/manageadmin/manageadmin.component.ts